import BaseDialog from "./BaseDialog";
import Player from "../../utilities/Player";
import { getGlobalSettings } from "../../stores";

const player = new Player();

export default class SampleDialogPreviewDialog extends BaseDialog {
    constructor(props) {
        super(props);
        this.state = {
            playing: null
        };
    }

    playDialogs(dialogs) {
        // promise queue
        let queue = Promise.resolve();
        dialogs.forEach(d => {
            // add dialogs to the queue
            queue = queue.then(() => {
                this.setState({playing: d.text});
                return player.play(d.text, d.voiceId);
            });
        });
        // play dialogs
        queue.catch(() => Promise.resolve()).then(() => {
            this.setState({playing: null});
        });
    }

    getSampleDialogs() {
        const lang = getGlobalSettings().language;
        return window.apm.serialized.dialogs.map((uc, ucIdx) => {
            const dialogs = [];
            uc.nodes.forEach((n, nIdx) => {
                let text = "";
                if (n.type === "prompt") {
                    const prompt = window.apm.getNode(n.parentComponentID);
                    if (prompt && prompt._class === "PromptNodeModel") {
                        text = prompt.props.config.text[lang];
                        if (uc.substitutions) {
                            Object.keys(uc.substitutions).forEach(v => {
                                const sub = uc.substitutions[v];
                                if (sub) {
                                    text = text.replace(new RegExp(`{{${v}}}`, "g"), sub);
                                }
                            });
                        }
                    }
                }
                if (n.type === "system" || n.type === "input") {
                    text = n.text;
                }
                const ttsText = text.replace(/{{.*}}/, "blank");
                const line = <span key={n.id + nIdx} className={n.type === "system" ? "system" : ""}>{text + " "}</span>;
                const lineType = n.type === "system" ? "prompt" : n.type;
                if (dialogs.length === 0 || dialogs[dialogs.length - 1].type !== lineType) {
                    dialogs.push({
                        lines: [line],
                        type: lineType,
                        text: ttsText,
                        voiceId: n.type === "prompt" ? (uc.promptVoice || 1099511628260) : (uc.inputVoice || 1099511628298)
                    });
                } else {
                    const last = dialogs[dialogs.length - 1];
                    last.lines.push(line);
                    last.text += n.type === "system" ? "" : ttsText;
                }
            });
            return <div key={uc.name + ucIdx}>
                <table><tbody>
                    <tr>
                        <td className="action">
                            {!this.state.playing && <i className="fe icon-play-circle" onClick={() => {
                                this.playDialogs(dialogs);
                            }}/>}
                        </td>
                        <td><div className="title">{uc.name}</div></td>
                    </tr>
                    <tr>
                        <td className="action" />
                        <td><p className="description">{uc.description}</p></td>
                    </tr>
                </tbody></table>
                <table className="dialogs"><tbody>
                {dialogs.length > 0 && dialogs.map((d, idx) => {
                    return <tr key={uc.name + ucIdx + "-" + idx}>
                        {d.text === this.state.playing && <td className="action playing">
                            <i className="fe icon-stop-circle" onClick={() => {
                                player.stop(true);
                            }}/>
                        </td>}
                        {d.text !== this.state.playing && <td className={"action"}>
                            {!this.state.playing && <i className="fe icon-play-circle" onClick={() => {
                                this.setState({playing: d.text});
                                return player.play(d.text, d.voiceId).catch(() => Promise.resolve()).then(() => {
                                    this.setState({playing: null});
                                });
                            }}/>}
                        </td>}
                        <td><p className={"preview " + d.type}>{d.lines}</p></td>
                    </tr>
                })}
                </tbody></table>
            </div>
        });
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        const {client, application, version} = window.apm.serialized;
        return (
            <div className="dialog-present-container">
                <div className="top">
                    <div className="header">
                        <p className="headline">Sample Dialogs</p>
                        <div className="app-info">
                            <span>{client}</span>
                            <br />
                            <span>{application}</span>
                            <br />
                            <span>{version}</span>
                        </div>
                    </div>
                    <hr />
                </div>
                <div className="content">
                    {this.getSampleDialogs()}
                </div>
            </div>
        );
    }
}